export enum BackgroundType {
  VIDEO = 'video',
  IMAGE = 'image',
  DEFAULT = 'default',
}
